import React, { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";

function JiliFreeSpinsPromoFun(props) {
  const {
    app: { brandId },
    theme,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const domain = "Fun88"

  return (
    <>
      <InformationWrapper>
        <ContentWrapper>
          {/* Top Info Banner */}
          <TopInfoCard>
            Start 2026 on <span className="brand">{domain}</span> with 26 free
            spins on Jili Slots. Sign up, launch your first <br /> Jili game, and spin
            instantly.
          </TopInfoCard>

          {/* How to Participate */}
          <SectionHeading>How to Participate</SectionHeading>

                 <StepsRow>
                      <StepCard>
                         <img
                      src={`${config.imageV3Host}/static/cashsite/${theme.image.jilliFreeSpinsSteps01Desk}`}
                      alt="Model"
                      className="modelImg"
                    />
                      </StepCard>
          
                      <StepCard>
                        <img
                      src={`${config.imageV3Host}/static/cashsite/${theme.image.jilliFreeSpinsSteps02Desk}`}
                      alt="Model"
                      className="modelImg"
                    />
                      </StepCard>
          
                      <StepCard>
                      <img
                      src={`${config.imageV3Host}/static/cashsite/${theme.image.jilliFreeSpinsSteps03Desk}`}
                      alt="Model"
                      className="modelImg"
                    />
                      </StepCard>
                    </StepsRow>

          {/* Terms and Conditions */}
          <TermsCard>
            <h3>Terms & Conditions</h3>

            <ul>
              <li>Valid once per user</li>
              <li>
                Free spin value: <b>₹1 per spin</b>
              </li>
              <li>
                <b>Free spins are credited</b> upon first launch of any Jili
                Slots game
              </li>
              <li>Slot bonus rules apply</li>
              <li>Bonus winnings subject to wagering of 5x</li>
              <li>General {domain} terms & conditions apply</li>
            </ul>
          </TermsCard>
        </ContentWrapper>
      </InformationWrapper>

    </>
  );
}

export default withTheme(withAppContext(JiliFreeSpinsPromoFun));

/* ===================== STYLES ===================== */

const InformationWrapper = styled.div`
  width: 100%;
  padding: 4rem 0;
  background: #ebebeb;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const ContentWrapper = styled.div`
  width: 980px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TopInfoCard = styled.div`
  width: 820px;
  background: #fff;
  border-radius: 10px;
  padding: 22px 28px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
  line-height: 1.4;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.06);

  .brand {
    font-weight: 700;
    color: rgba(0, 0, 0, 0.85);
  }
`;

const SectionHeading = styled.h2`
  margin-top: 2.2rem;
  margin-bottom: 1.4rem;
  font-size: 14px;
  font-weight: 700;
  color: #06A6FF;
  text-align: center;
`;

const StepsRow = styled.div`
  display: flex;
  gap: 1.6rem;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
`;

const StepCard = styled.div`
  width: 270px;
  height: 110px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  & img {
    width: 100%;
    height: auto;
  }

  .stepNum {
    position: absolute;
    top: 12px;
    left: 16px;
    font-size: 13px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.55);
  }

  .stepText {
    width: 52%;
    font-size: 15px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.72);
    line-height: 1.1;
    padding-top: 16px;

    .brand {
      font-weight: 800;
      color: rgba(0, 0, 0, 0.82);
    }
  }

  .stepImg {
    width: 42%;
    display: flex;
    justify-content: flex-end;

    img {
      width: 100%;
      max-width: 125px;
      height: 85px;
      border-radius: 10px;
      object-fit: cover;
    }
  }
`;

const TermsCard = styled.div`
  width: 410px;
  background: #fff;
  border-radius: 12px;
  padding: 26px 34px;
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.08);
  text-align: left;

  h3 {
    margin: 0 0 1rem 0;
    font-size: 14px;
    font-weight: 700;
    color: #06A6FF;
  }

  ul {
    margin: 0;
    padding-left: 1.2rem;
    display: flex;
    flex-direction: column;
    gap: 0.7rem;

    li {
      font-size: 13px;
      color: #444;
      line-height: 1.35;

      b {
        font-weight: 700;
        color: #444;
      }
    }
  }
`;
